import { render, staticRenderFns } from "./updateSizeTemplate.vue?vue&type=template&id=ddefee6a&scoped=true"
import script from "./updateSizeTemplate.vue?vue&type=script&lang=js"
export * from "./updateSizeTemplate.vue?vue&type=script&lang=js"
import style0 from "./updateSizeTemplate.vue?vue&type=style&index=0&id=ddefee6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddefee6a",
  null
  
)

export default component.exports